import { Deserializable } from './deserializable';
import { EXERCISEPART_RATING_START_OPTIONS } from 'projects/core/src/lib/constants';
import { BehavioranchorModel } from './behavioranchor.model';
import { BaseModel } from './base.model';

export class ExercisepartModel extends BaseModel implements Deserializable {

  // columns
  name: string;
  type: string;
  position: number;
  duration: number;
  for_candidate: boolean; // tslint:disable-line: variable-name
  for_observer: boolean; // tslint:disable-line: variable-name
  rating_start: string; // tslint:disable-line: variable-name
  rating_duration: number; // tslint:disable-line: variable-name
  unlock_days: number; // tslint:disable-line: variable-name

  // relations
  exerciseversion: any;
  behavioranchors: Array<BehavioranchorModel>;

  deserialize(input: any): this {
    Object.assign(this, input);
    let behavioranchors = null;
    if (this.behavioranchors !== null && this.behavioranchors !== undefined) {
      behavioranchors = [];
      this.behavioranchors.forEach((behavioranchor: BehavioranchorModel) => {
        behavioranchors.push(new BehavioranchorModel().deserialize(behavioranchor, false));
      });
    }
    this.behavioranchors = behavioranchors;
    this.loaded = true;
    return this;
  }

  public getRatingStartName(): string {
    return EXERCISEPART_RATING_START_OPTIONS[this.rating_start];
  }

}
